module.exports = __webpack_public_path__ + "img/Vonage_Jumper_icon_blackbg_horizontal.0b79075b.svg";